var _a;
import React, { useMemo } from 'react';
import { DarkModeProvider, FunctionColor, LightModeProvider, SupportingColor } from '@lux/core';
import { OpenCampaignCardOverlay } from '@lux/campaign-card';
import { Flag, FlagType } from '@lux/flags';
import { PlusBadgeV2, PlusLogoPill } from '@lux/plus-badge';
import { HeartFilledColorXS } from '@lux/zds-icons';
import { Translate, TranslateScope } from '@pegasus/translation';
import { DeliveryPromise } from '../constants';
var PromiseIcon = (_a = {},
    _a[DeliveryPromise.Valentines] = React.createElement(HeartFilledColorXS, { color: SupportingColor.info }),
    _a);
export var CampaignCardOverlay = function (_a) {
    var deliveryPromise = _a.deliveryPromise, hasLogo = _a.hasLogo, isEarlyAccess = _a.isEarlyAccess, isExclusive = _a.isExclusive, hasLeavingSoonFlag = _a.hasLeavingSoonFlag;
    var flags = useMemo(function () {
        if (isEarlyAccess) {
            return (React.createElement(Flag, { flagStyle: FlagType.BRIGHT },
                React.createElement(TranslateScope, { path: "plus" },
                    React.createElement(Translate, { message: "campaign.live", raw: true }))));
        }
        if (hasLeavingSoonFlag) {
            return (React.createElement(DarkModeProvider, null,
                React.createElement(Flag, { style: {
                        backgroundColor: '#9C1292',
                        color: "".concat(FunctionColor.function100),
                    } },
                    React.createElement(TranslateScope, { path: "leavingSoon" },
                        React.createElement(Translate, { message: "label", raw: true })))));
        }
        if (deliveryPromise === null || deliveryPromise === void 0 ? void 0 : deliveryPromise.type) {
            return (React.createElement(Flag, { flagStyle: FlagType.BRIGHT, style: { display: 'flex', alignItems: 'center', gap: 4 } },
                PromiseIcon[deliveryPromise.type],
                React.createElement("span", { style: { overflow: 'hidden', textOverflow: 'ellipsis' } }, deliveryPromise === null || deliveryPromise === void 0 ? void 0 : deliveryPromise.text)));
        }
        return null;
    }, [deliveryPromise === null || deliveryPromise === void 0 ? void 0 : deliveryPromise.text, deliveryPromise === null || deliveryPromise === void 0 ? void 0 : deliveryPromise.type, isEarlyAccess, hasLeavingSoonFlag]);
    return (React.createElement(OpenCampaignCardOverlay, { flags: flags, 
        // TODO: Provide a label for flag list.
        flagsLabel: "", withLogo: hasLogo }, isEarlyAccess || isExclusive ? (React.createElement(TranslateScope, { path: "plus" },
        React.createElement(LightModeProvider, null,
            isEarlyAccess && (React.createElement(PlusBadgeV2, { dynamicFontSize: false, pill: React.createElement(PlusLogoPill, null), style: { display: 'flex' } },
                React.createElement(Translate, { message: "plusEarlyAccess", raw: true }))),
            isExclusive && (React.createElement(PlusBadgeV2, { dynamicFontSize: false, pill: React.createElement(PlusLogoPill, null), style: { display: 'flex' } },
                React.createElement(Translate, { message: "exclusive.logoText", raw: true })))))) : null));
};
